export default __webpack_public_path__ + "static/media/logo.98e682b4.webp";